import React, { useEffect, useState } from "react";
import Preloading from "../../components/basics/Preloading";
import back from "../../assets/images/icons/arrow-right2.svg";
import { Link, useParams } from "react-router-dom";
import methods from "../../services/utility";
import apiMethod from "../../services/api-service";
import Paginations from "../../components/paginaton/Paginations";
import DeleteModal from "../../components/deleteModal/DeleteModal";

const CreateWarHouse = () => {
  const { branchId } = useParams();
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState();
  const [gridData, setGridData] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [createWareHouseModal, setCreateWareHouseModal] = useState(false);
  const [editWareHouseModal, setEditWareHouseModal] = useState(false);
  const [wareHouseType, setWareHouseType] = useState([]);
  const [categoryWareHouse, setCategoryWareHouse] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    restaurantId: restaurantId,
    parentId: null,
    title: "",
    code: "",
    size: 20,
    part: 1,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    description: "",
    warehouseType: 0,
    parentId: null,
    categoryId: 0,
    branchId: branchId,
    restaurantId: restaurantId,
  });

  const resetForm = () => {
    formModel.id = 0;
    formModel.branchId = branchId;
    formModel.code = "";
    formModel.title = "";
    formModel.description = "";
    formModel.restaurantId = restaurantId;
    formModel.parentId = null;
    formModel.categoryId = 0;
    formModel.warehouseType = 0;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.restaurantId = restaurantId;
    filterModel.title = "";
    filterModel.parentId = null;
    filterModel.code = "";
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const getGridData = async () => {
    setLoading(true);
    const resp = await apiMethod.getWarehouses(
      filterModel.branchId,
      filterModel.restaurantId,
      filterModel.title,
      filterModel.code,
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) {
      setTotalPages(resp.total);
      setGridData(resp.data);
    }
    setLoading(false);
  };

  const getCategory = async () => {
    const resp = await apiMethod.getWarehouseCategories(
      filterModel.branchId,
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) {
      setCategoryWareHouse(resp.data);
    }
  };

  const getWarHouseType = async () => {
    const resp = await apiMethod.getWarehouseTypes();
    if (methods.showApiErrors(resp)) {
      setWareHouseType(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getWarHouseType();
      await getCategory();
      setLoading(false);
    };
    bindData();
  }, []);

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const editItem = async (id) => {
    setEditWareHouseModal(true);
    setLoading(true);
    const resp = await apiMethod.getWarehouseInfo(id);
    if (methods.showApiErrors(resp)) {
      console.log({ "resp:::": resp });
      setFormModel({
        ...formModel,
        id: resp.data.id,
        title: resp.data.title,
        description: resp.data.description,
        code: resp.data.code,
        categoryId: resp.data.categoryId,
        warehouseType: resp.data.warehouseType,
      });
    }
    setLoading(false);
  };
  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const handleCreateModal = () => {
    setCreateWareHouseModal(true);
  };

  const addWarhouse = async () => {
    setLoading(true);
    const resp = await apiMethod.createWarehouse(formModel);
    if (methods.showApiErrors(resp)) {
      setCreateWareHouseModal(false);
      setEditWareHouseModal(false);
      resetForm();
      await getGridData();
    }
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeWarehouse(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}/${branchId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}/${branchId}`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                مدیریت انبار
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                مدیریت انبار
                <a
                  href={`/wareHouse/${restaurantId}/${branchId}`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="searchInput" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="searchInput" className="form-label">
                      کد
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.code}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            code: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="col-2 d-flex align-items-end"
                    style={{ marginBottom: "4px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="createButton ">
                      <button
                        class="btn btn-outline-purple custome-btn"
                        type="button"
                        onClick={handleCreateModal}
                      >
                        <span class="align-middle d-inline-block">
                          انبار جدید
                        </span>{" "}
                        <i class="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">نوع انبار</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.code}</td>
                        <td>
                          {{
                            1: "پایه",
                            2: "تولید",
                            3: "فروشگاه",
                          }[item.warehouseType] || "نامشخص"}
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className="btn btn-sm btn-outline-purple me-2"
                            type="button"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.part > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const createCategoryModalInfo = () => {
    return (
      <>
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          onClick={() => setCreateWareHouseModal(false)}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content px-3">
              <div className="modal-header">
                <h5 className="modal-title">افزودن انبار جدید</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setCreateWareHouseModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="col-md-12 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    نوع انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.warehouseType}
                    onChange={(e) => {
                      formModel.warehouseType = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {wareHouseType.map((item) => (
                      <option value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    دسته بندی انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.categoryId}
                    onChange={(e) => {
                      formModel.categoryId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {categoryWareHouse.map((item) => (
                      <option value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-12 mb-4">
                  <label htmlFor="title" className="form-label">
                    عنوان
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="title" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    className="form-control"
                    type="text"
                    rows={4}
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
                <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    class="btn custome-btn btn-link-purple"
                    onClick={() => setCreateWareHouseModal(false)}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    class="btn custome-btn btn-purple"
                    onClick={addWarhouse}
                  >
                    ثبت و ذخیره
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const editCategoryModalInfo = () => {
    return (
      <>
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          onClick={() => setEditWareHouseModal(false)}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content px-3">
              <div className="modal-header">
                <h5 className="modal-title">ویرایش انبار</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setEditWareHouseModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="col-md-12 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    نوع انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.warehouseType}
                    onChange={(e) => {
                      formModel.warehouseType = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {wareHouseType.map((item) => (
                      <option value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    دسته بندی انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.categoryId}
                    onChange={(e) => {
                      formModel.categoryId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {categoryWareHouse.map((item) => (
                      <option value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-12 mb-4">
                  <label htmlFor="title" className="form-label">
                    عنوان
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="title" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    className="form-control"
                    type="text"
                    rows={4}
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
                <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    class="btn custome-btn btn-link-purple"
                    onClick={() => setEditWareHouseModal(false)}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    class="btn custome-btn btn-purple"
                    onClick={addWarhouse}
                  >
                    ثبت و ذخیره
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <>
        {renderItems()}
        {createWareHouseModal && createCategoryModalInfo()}
        {editWareHouseModal && editCategoryModalInfo()}
        {showDeleteModal && (
          <DeleteModal
            showModal={showDeleteModal}
            closeModal={closeDeleteModal}
            deleteItem={deleteItem}
            text={"انبار"}
          />
        )}
      </>
    </div>
  );
};

export default CreateWarHouse;
